<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} tipo habitación
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-9">
              <div class="row">
                <div class="form-group col-lg-4">
                  <label>Nombre habitación<span class="required"></span></label>
                  <input type="text" id="category_description"
                    [ngClass]="{'parsley-error': (submitted && f['description'].errors)}" formControlName="description"
                    required="true" class="form-control" [autofocus]>
                  <div *ngIf="submitted && f['description'].errors">
                    <small class="text-danger" *ngIf="f['description'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['description'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>Abreviación<span class="required"></span></label>
                  <input type="text" class="form-control" formControlName="abbreviation" required placeholder="Ej: MAT">
                  <div *ngIf="submitted && f['abbreviation'].errors">
                    <small class="text-danger" *ngIf="f['abbreviation'].errors['required']">Abreviación es
                      requerido</small>
                    <small class="text-danger" *ngIf="f['abbreviation'].errors['minlength']">Abreviación Muy
                      corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-2">
                  <label>
                    N°capacidad <span class="required"></span>
                  </label>
                  <input type="text" class="form-control bold text-primary" numeric onclick="click_input(this)"
                    formControlName="capacity" required>
                </div>
                <div class="form-group col-lg-2">
                  <label>Esp.Cama</label>
                  <input type="text" class="form-control" formControlName="beds">
                </div>
                <div class="form-group col-lg-2">
                  <label>Esp.Tv</label>
                  <input type="text" class="form-control" formControlName="tvs">
                </div>
                <div class="form-group col-lg-2">
                  <label>Esp.Tamaño m2</label>
                  <input type="text" class="form-control" formControlName="size_mt">
                </div>
                <div class="form-group col-lg-3">
                  <label>
                    P.Base Venta<span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold text-primary" numeric decimals="2"
                      onclick="click_input(this)" formControlName="price_public" required>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>
                    P.Base Web<span class="required"></span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold text-primary" numeric decimals="2"
                      onclick="click_input(this)" formControlName="price_web" required>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>
                    P.Persona Adicional
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold text-primary" numeric decimals="2"
                      onclick="click_input(this)" formControlName="price_person_additional">
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>
                    P.Cama Adicional
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend"><span
                        class="input-group-text">{{toolsService.momeySol()}}</span></span>
                    <input type="text" class="form-control bold text-primary" numeric decimals="2"
                      onclick="click_input(this)" formControlName="price_bed_additional">
                  </div>
                </div>

                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox float-left">
                    <input type="checkbox" class="custom-control-input" formControlName="is_show" id="is_show">
                    <label class="custom-control-label p-t-3" for="is_show">¿Es activo?</label>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label>Descripción</label>
                  <textarea rows="3" class="no-resize form-control" formControlName="description_type"></textarea>
                </div>
                <div class="form-group col-lg-12">
                  <label>Iframe fotos 360°
                    (referencia: <a target="_blank" class="text-primary" href="https://kuula.co/">Click para ver</a>)
                  </label>
                  <textarea rows="3" class="no-resize form-control" formControlName="iframe_360"></textarea>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <p class="text-center p-t-15">
                <ng-container *ngIf="item.value.url_image != null">
                  <img width="250" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                </ng-container>
                <ng-container *ngIf="item.value.url_image == null">
                  <ng-container *ngIf="imageUrl == null">
                    <img id="output" width="250" src="/images/default.png" />
                  </ng-container>
                  <ng-container *ngIf="imageUrl != null">
                    <img width="250" height="165" [src]="imageUrl" alt="Preview">
                  </ng-container>
                </ng-container>
              </p>
              <p class="text-center">
                <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                  Seleccionar Imagen
                  <!-- <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                    style="visibility: hidden;"> -->
                  <input id="file" type="file" accept=".png, .jpg, .jpeg" style="visibility: hidden;"
                    (change)="onFileSelectedShowCrop($event)">
                </label>
              </p>
            </div>

            <div class="col-lg-12 m-t-10">
              <p class="form__group__title"> <i class="fas fa-images m-r-3"></i>Galería fotos <input #fileInput
                  type="file" class="m-l-15" (change)="fileChangeEvent($event)" accept="image/*" multiple></p>
              <div class="col-12">
                <div class="loading content_loading" id="box-loading-gallery">
                  <div class="spinner" role="status">
                    <div class="inner one"></div>
                    <div class="inner two"></div>
                    <div class="inner three"></div>
                  </div>
                  <p id="text">Cargando...</p>
                </div>
                <ng-container *ngIf="isCropping">
                  <div class="loading content_loading" id="box-loading-gallery">
                    <div class="spinner" role="status">
                      <div class="inner one"></div>
                      <div class="inner two"></div>
                      <div class="inner three"></div>
                    </div>
                    <p id="text">Cambiando imagen...</p>
                  </div>
                </ng-container>
                <div class="row">
                  <div class="col-12">
                    <div *ngIf="imageChangedEvent" style="width: 30%;">
                      <image-cropper class="custom-cropper" [imageChangedEvent]="imageChangedEvent"
                        [maintainAspectRatio]="true" [aspectRatio]="4 / 3" [resizeToWidth]="1000" format="jpeg"
                        (imageCropped)="imageCropped($any($event))">
                      </image-cropper>
                      <button type="button" class="btn btn-outline-secondary mt-2 me-2 m-r-5"
                        [disabled]="currentIndex === 0" (click)="goToPrevious()">← Anterior</button>
                      <button type="button" class="btn btn-warning mt-2 m-r-5" (click)="skipCurrent()">Omitir</button>
                      <button type="button" class="btn btn-info mt-2" (click)="cropAndNext()">Recortar y
                        siguiente</button>
                    </div>
                  </div>
                  <div class="col-12 p-0 m-t-15 m-b-30">
                    <div *ngIf="croppedImages.length > 0">
                      <h5 class="f-s-13 m-b-5">Imágenes preseleccionadas: <span
                          class="badge badge-warning text-dark bold f-s-12">
                          <i class="fas fa-info-circle m-l-5"></i>
                          No olvider guardar para aplicar cambios
                        </span></h5>
                      <div class="d-flex flex-wrap">
                        <div class="position-relative" *ngFor="let img of croppedImages; let i = index">
                          <img [src]="img" class="m-2" style="max-width: 200px; height: 140px; border: 1px solid #ccc;">
                          <button type="button" class="btn btn-danger btn-sm position-absolute top-0 end-0"
                            style="z-index: 1; right: 5px;" (click)="removeImage(i)">
                            ✕
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <ng-container *ngIf="photosOld.length > 0">
                    <div class="col-12">
                      <p class="bold text-primary f-s-15">IMÁGENES SUBIDAS:</p>
                    </div>
                  </ng-container>
                  <div class="col-12">
                    <ng-container *ngIf="photosOld.length > 0">
                      <div class="row" #sortableContainer>
                        <div class="col-lg-3 m-b-35 p-l-10 p-r-10"
                          *ngFor="let file of photosOld; let index_ = index; trackBy: trackById"
                          [attr.data-id]="file.id" style="cursor: move;">
                          <img style="width: 100%; height: 80%; border-radius: 4px;" src="tenants/{{ file.url_image }}"
                            alt="Image Preview" />
                          <div class="row m-t-5">
                            <div class="col-lg-12">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <div class="input-group-text">
                                    <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="right"
                                      data-original-title="Descripción de la imágen"></i>
                                  </div>
                                </div>
                                <input type="text" class="form-control sale__input" placeholder="Descripción"
                                  (keyup)="changeTagImageOld($event.target, index_)" [value]="file.tag" />
                                <div class="input-group-append">
                                  <i class="far fa-trash-alt pointer f-s-17 text-danger m-t-5 m-l-5"
                                    (click)="removeImageOld(index_)"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- sample modal content -->
  <div id="modalCroppedCover" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title mt-0">Recortar imagen</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="imageCoverChangedEvent" style="width: 70%;">
            <image-cropper [imageChangedEvent]="imageCoverChangedEvent" [maintainAspectRatio]="true"
              [aspectRatio]="4 / 3" [resizeToWidth]="1000" format="jpeg" (imageCropped)="imageCroppedCover($event)">
            </image-cropper>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" (click)="confirmCrop()">Seleccionar imagen</button>
        </div>
      </div>
    </div>
  </div>
</div>
